import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useFeatureSettings } from '@office-start/feature-settings-service';
import { OfficeHomeContext } from '@office-start/office-home-context';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import { useContext } from 'react';
var STANDALONE_ORIGINS = [
    'https://copilot.cloud.microsoft',
    'https://copilot.cloud-dev.microsoft',
    'https://ccm.mobile.m365.svc.cloud.microsoft',
];
export function useCopilotRoute() {
    var _a;
    var componentContext = useOfficeComponentContext().data;
    var isCopilotRoute = ((_a = componentContext === null || componentContext === void 0 ? void 0 : componentContext.browserPathAndQueryString) === null || _a === void 0 ? void 0 : _a.includes('/copilot')) ||
        false;
    return isCopilotRoute;
}
export function useCopilotAMode() {
    var _a;
    var featureSettings = useFeatureSettings().data;
    return ((_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result.copilot) === null || _a === void 0 ? void 0 : _a.mode) === 'ModeA';
}
export function usePinningEligible() {
    var _a, _b, _c;
    var userEntitlements = useUserEntitlements().data;
    var eligibility = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotEligibilityV3;
    return !!(((_b = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _b === void 0 ? void 0 : _b.isCommercialUser) &&
        (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isCopilotEligible) &&
        (eligibility === null || eligibility === void 0 ? void 0 : eligibility.cohort) !== 'BCAIS' &&
        ((_c = eligibility === null || eligibility === void 0 ? void 0 : eligibility.pinningEligibility) === null || _c === void 0 ? void 0 : _c.includes('M365')));
}
export function useBCAIS() {
    var _a, _b, _c;
    var userEntitlements = useUserEntitlements().data;
    var eligibility = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotEligibilityV3;
    return !!(((_b = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _b === void 0 ? void 0 : _b.HasCopilotBusinessChat) ||
        (((_c = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _c === void 0 ? void 0 : _c.isCommercialUser) &&
            (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isCopilotEligible) &&
            (eligibility === null || eligibility === void 0 ? void 0 : eligibility.cohort) === 'BCAIS'));
}
export function useCopilotEligible() {
    var _a;
    var userEntitlements = useUserEntitlements().data;
    var eligibility = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotEligibilityV3;
    return !!(eligibility === null || eligibility === void 0 ? void 0 : eligibility.isCopilotEligible);
}
export function useCopilotEligibilityReasons() {
    var _a;
    var userEntitlements = useUserEntitlements().data;
    var eligibility = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.userCopilotEligibilityV3;
    return eligibility;
}
export function useCopilotBMode() {
    var _a;
    var featureSettings = useFeatureSettings().data;
    return ((_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result.copilot) === null || _a === void 0 ? void 0 : _a.mode) === 'ModeB';
}
export function useStandaloneCopilotApp() {
    var _a;
    var isStandaloneCopilot = useContext(OfficeHomeContext).isStandaloneCopilot;
    var isStandalone = Boolean(isStandaloneCopilot);
    if (isStandalone) {
        return isStandalone;
    }
    return STANDALONE_ORIGINS.includes((_a = window.location) === null || _a === void 0 ? void 0 : _a.origin);
}
//# sourceMappingURL=useCopilotRoute.js.map